<div class="app-panel-header-content">
    <div [class.indicator-expanded]="_isExpanded()" class="app-expansion-indicator"></div>
    <ng-content select="appExpansionPanelTitle"></ng-content>
    <ng-content></ng-content>
</div>
